import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

let refreshPromise = null;

const requestNewToken = async () => {
    const storedRefreshToken = localStorage.getItem("refreshToken");

    if (!storedRefreshToken) {
        throw new Error("No refresh token available");
    }

    // withCredentials matches the shared `api` instance (utils/axios.js) -
    // without it, this cross-origin call drops the ARRAffinity cookie Azure
    // App Service uses for instance affinity, so the request can land on a
    // different backend instance than the one that issued/rotated the
    // token and get rejected as "invalid" even when it's genuinely fresh.
    const res = await axios.post(`${API_URL}/auth/refresh`, { refreshToken: storedRefreshToken }, { withCredentials: true });

    // /auth/refresh returns the AuthResponseDTO flat ({ accessToken, refreshToken }),
    // unlike /auth/login which wraps it in { tokens: {...} } - accept both.
    const tokens = res.data?.tokens ?? res.data;
    const newAccessToken = tokens?.accessToken;
    const newRefreshToken = tokens?.refreshToken || storedRefreshToken;

    if (!newAccessToken) {
        throw new Error("Refresh response missing accessToken");
    }

    localStorage.setItem("accessToken", newAccessToken);
    localStorage.setItem("refreshToken", newRefreshToken);

    return newAccessToken;
};

// Multiple requests can hit 401 at the same time; share a single in-flight
// refresh call instead of firing one /auth/refresh per request.
export const refreshAccessToken = () => {
    if (!refreshPromise) {
        refreshPromise = requestNewToken().finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
};
